import { createClient } from "contentful";

const spaceId = process.env.REACT_APP_CONTENTFUL_SPACE_ID;
const accessToken = process.env.REACT_APP_CONTENTFUL_ACCESS_TOKEN;

const client = createClient({
  space: spaceId || "blml0wiarabv",
  environment: "master",
  accessToken: accessToken || "tZtGlzKwd-F_HAnxrp1QmyqmBJQuPi29tHoQ2Uts4Gg",
});

export default client;
